import React from 'react';

export default function Section({ title, children }) {
  return (
    <div className="template-section">
      <SectionTitle title={title} />
      {children}
    </div>
  );
}

function SectionTitle({ title }) {
  return <div className="section-title">{title}</div>;
}
